/* NALLI — voucher isolation gate (WS7).
 *
 * Replaces live's patched assets/product-form.js hunks 3 + 5
 * (specs/assets--product-form.js.md) WITHOUT touching core 4.1.3 product-form.js:
 *
 *  1. Capture-phase document `submit` listener: when the PDP form's #dataform
 *     flag (rendered by blocks/nalli-buy-buttons.liquid) is "0" — i.e. the cart
 *     already holds the other kind of item (voucher vs non-voucher) — the submit
 *     is blocked before core product-form.js ever sees it, and the dedicated
 *     message is shown.
 *  2. Backend error rewrite: cart-transform errors mentioning "Voucher" are
 *     rewritten to "This product is only available for shipping in India"
 *     (vouchers double as the India-only shipping gate). Core 4.1.3 writes
 *     response.message into [ref="addToCartTextError"]; a MutationObserver
 *     rewrites it after the fact instead of patching the private fetch handler.
 *
 * Contract note (WS8): the shared shipping-note writer (`cm-cart-notes` cart
 * attribute) is WS8's `updateShippingNote()` listening for cart-update events
 * at document level. Both core product-form.js and nalli-buy-buttons.js
 * dispatch CartLinesUpdateEvent on every successful add, so no shipping-note
 * code is needed here — live's product-form.js hunk 2 is superseded.
 */

const VOUCHER_MIX_MESSAGE =
  'Kindly note that gift vouchers and other products need to be purchased in seperate orders.';
const VOUCHER_INDIA_MESSAGE = 'This product is only available for shipping in India';

function showError(component, message) {
  const errorEl = component.querySelector('[ref="addToCartTextError"]');
  if (!errorEl) return;
  errorEl.classList.remove('hidden');
  const textNode = errorEl.childNodes[2];
  if (textNode) {
    textNode.textContent = message;
  } else {
    errorEl.appendChild(document.createTextNode(message));
  }
}

/* 1. Submit gate — WINDOW capture phase, so it runs before core's declarative
 * on:submit (component.js binds that on document capture; 2026-10-09 fix). */
window.addEventListener(
  'submit',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const component = target.closest('product-form-component, readymade-product-form-component');
    if (!component) return;

    const flag = component.querySelector('#dataform');
    if (flag && flag.textContent.trim() === '0') {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(component, VOUCHER_MIX_MESSAGE);
    }
  },
  true
);

/* 2. "Voucher" backend-error rewrite. */
function observeErrorEl(errorEl) {
  if (errorEl.dataset.nalliVoucherObserved === 'true') return;
  errorEl.dataset.nalliVoucherObserved = 'true';

  const observer = new MutationObserver(() => {
    const textNode = errorEl.childNodes[2];
    const text = textNode?.textContent ?? '';
    if (text.includes('Voucher') && text !== VOUCHER_INDIA_MESSAGE) {
      textNode.textContent = VOUCHER_INDIA_MESSAGE;
    }
  });
  observer.observe(errorEl, { childList: true, characterData: true, subtree: true });
}

function init() {
  document
    .querySelectorAll(
      'product-form-component [ref="addToCartTextError"], readymade-product-form-component [ref="addToCartTextError"]'
    )
    .forEach(observeErrorEl);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
